module.exports = __webpack_public_path__ + "img/21.3127cf01.png";